/* eslint semi:0 */
import 'core-js'
import 'application/bootstrap_post_page'
import React from 'react'
import { mountAll, } from 'utils/component'
import { mountAll as rMountAll, } from 'utils/rComponent'
import navbarComponent from 'components/navbarComponent'
import fanorakelComponent from 'components/fanorakelComponent'
import { MOUNT_POINTS, } from 'config/preRenderedSelectorsConfig'
import userToolbarComponent from 'components/userToolbarComponent'
import googleSearchComponent from 'components/googleSearchComponent'
import adminDropdownComponent from 'components/adminDropdownComponent'
import { isPundit, isEmbededPost, } from 'application/pageDataObject'
import coverSocialButtonsComponent from 'components/socialButtons/coverSocialButtonsComponent'
import footerSocialButtonsComponent from 'components/socialButtons/footerSocialButtonsComponent'
import initFacebookComments from 'components/facebookCommentsComponent'
import initializeEditionSelection from 'components/edition_dropdown/editionDropdown'

//redux
import initCookieDisclaimer from 'components/cookieDisclaimer/cookieDisclaimerContainer'
import initPostMetadataStats from 'components/post_metadata/postMetadataContainer'
import initSocialBarComponents from 'components/reactions/socialBarContainer'
import initCommunityDisclaimer from 'components/community_disclaimer/communityDisclaimerContainer'
import initJwPlayers from 'components/jwplayer/jwplayerContainer';


initializeEditionSelection()
mountAll({
  // TODO: instead of using css classes as selectors we should do something like data-mount-component
  [MOUNT_POINTS.FANORAKEL]: fanorakelComponent,
  [MOUNT_POINTS.ADMIN_DROPDOWN]: adminDropdownComponent,
  [MOUNT_POINTS.SEARCH_COMPONENT]: googleSearchComponent,
  [MOUNT_POINTS.NAVBAR_SOCIAL_COMPONENT]: navbarComponent,
  [MOUNT_POINTS.USER_MENU_DROPDOWN]: userToolbarComponent,
  [MOUNT_POINTS.FOOTER_SOCIAL_ICONS]: footerSocialButtonsComponent,
  [MOUNT_POINTS.SHARE_COVER_COMPONENT]: coverSocialButtonsComponent,
});

if (isPundit) {
  const PunditMatchTimeComponent = require('components/pundit/punditMatchTimeComponent')
  const PunditVbetComponent = require('components/pundit/punditVbetComponent')
  const ExternalTopPredictors = require('components/pundit/punditExternalTopPredictorsComponent')
  rMountAll({
    [MOUNT_POINTS.PUNDIT_MATCH_TIME]: <PunditMatchTimeComponent/>,
    [MOUNT_POINTS.PUNDIT_VBET]: <PunditVbetComponent/>,
    [MOUNT_POINTS.PUNDIT_TOP_PREDICTORS]: <ExternalTopPredictors/>,
  })
}
initCookieDisclaimer(!isEmbededPost)
initPostMetadataStats()
initSocialBarComponents()
initCommunityDisclaimer()
initFacebookComments()
initJwPlayers()




// WEBPACK FOOTER //
// ./provolution/app/views/provolution/post_page/post_page.js